import api from '../../api'
import {normalize} from 'normalizr';
import * as selectors from './record.selectors';
import {sendNotification} from '../../application.actions'

export const RECORD_SAVED = 'RECORD_SAVED';
export const RECORD_UPDATED = 'RECORD_UPDATED';
export const RECORD_CLEARED = 'RECORD_CLEARED';
export const RECORD_RETRIEVED = 'RECORD_RETRIEVED';
export const RECORD_STATUS_CHANGED = 'RECORD_STATUS_CHANGED';
export const DOCUMENTATION_DELETED = 'DOCUMENTATION_DELETED';
export const DOCUMENTATION_UPLOADED = 'DOCUMENTATION_UPLOADED';
export const REVIEW_RETRIEVED = 'REVIEW_RETRIEVED';
export const ATTENDING_PHYSICIAN_SAVED = 'ATTENDING_PHYSICIAN_SAVED';
export const FORM_PRINTED = 'FORM_PRINTED';

export const printForm = (recordId) => async (dispatch, getState) => await api(dispatch)
    .download(`records/${recordId}/print`, 'application/pdf');

export const fetchReview = (recordId) => async (dispatch, getState) => {
  return await api(dispatch).get(`records/${recordId}/review`, response => ({
    type: REVIEW_RETRIEVED, payload: response     
  }));
};

export const clearRecord = () => ({type: RECORD_CLEARED});

export const fetchRecord = (periodId, recordId) => async (dispatch, getState, {schema}) => {
  return await api(dispatch).get(`periods/${periodId}/records/${recordId}`, response => ({
    type: RECORD_RETRIEVED, payload: {
      ...normalize(response, schema.patient),
      periodId
    }
  }));
};

export const uploadDocumentation = (recordId, file) => async (dispatch, getState, {schema}) => {
  const periodId = getState().record.periodId;
  const userFacilityId = getState().application.user.facility;
  const data = new FormData();
  data.append('file', file);
  const uri = `periods/${periodId}/records/${recordId}/documentation`;
  return await api(dispatch).upload(uri, data, response => {
    const data = Array.isArray(response) ? response.find(x => x.type === 'FileAddedToRecord') : response;
    return ([
      {type: DOCUMENTATION_UPLOADED, payload: {...normalize(data, schema.documentation), userFacilityId}},
      sendNotification(`${file.name} uploaded successfully.`)
    ]);
  }, e => console.log('upload', e));
};

export const deleteDocumentation = (recordId, document) => async (dispatch, getState) => {
  const periodId = getState().record.periodId;
  return await api(dispatch).delete(`periods/${periodId}/records/${recordId}/documentation/${document.id}`, response => [
    {type: DOCUMENTATION_DELETED, payload: response.id},
    sendNotification(`${document.fileName} deleted.`)
  ]);
};

export const getDocumentationUrl = (recordId, documentationId) => async (dispatch, getState) => {
  const periodId = getState().record.periodId;
  const response = await api(dispatch)
    .get(`periods/${periodId}/records/${recordId}/documentation/${documentationId}`,
      data => ({type: 'DOCUMENTATION_URL_FETCHED', payload: {...data}})
    );
  return response.uri;
};

export const saveRecord = ({formData = {}, compliant = false, complete = false} = {}) => async (dispatch, getState) => {
  const record = selectors.record(getState());
  const periodId = record.periodId;
  
  const formValue = mapFormValue(formData);
  
  const compliant = formData.compliantSelection.value ? formData.compliantSelection.value === 'yes' : '';

  const body = {...formValue,
    formData: JSON.stringify(formData), 
    compliant: compliant,
    reviewer: formData.reviewer.value, 
    complete, 
    withReviewForm: formData !== '{}'};

  return await api(dispatch).post(`periods/${periodId}/records/${record.id}/review`, body, response => [
    {type: RECORD_SAVED, payload: response},
    sendNotification(`${record.name} review saved.`)
  ]);
};

export const saveAttendingPhysician = (attendingPhysician = '') => async (dispatch, getState) => {
  const record = selectors.record(getState());
  const periodId = record.periodId;
  
  const body = {attendingPhysician};
  return await api(dispatch).post(`periods/${periodId}/records/${record.id}/physician`, body, response => [
    {type: ATTENDING_PHYSICIAN_SAVED, payload: response},
    sendNotification(`Attending physician saved.`)
  ]);
};

export const changeRecordStatus = recordStatus => async (dispatch, getState) => {
  const record = selectors.record(getState());
  const periodId = record.periodId;
  
  const body = {recordStatus};
  return await api(dispatch).post(`periods/${periodId}/records/${record.id}/status`, body, response => [
    {type: RECORD_STATUS_CHANGED, payload: response},
    sendNotification(`Review status updated.`)
  ]);
};

export const submitRecord = (complete = false) => async (dispatch, getState) => {
  const record = selectors.record(getState());
  const periodId = record.periodId;

  const generateActions = response => {
    const events = Array.isArray(response) ? response : [response];
    const submitted = events.find(x => x.type === 'RecordSubmitted');
    return [
      submitted ? {type: RECORD_SAVED, payload: submitted} : {type: 'NO_ACTION'},
      submitted ? sendNotification(`${record.name} status changed to ${submitted.recordStatus}.`) :
        sendNotification(`${record.name} saved.`)
    ];
  };

  return await api(dispatch).post(`periods/${periodId}/records/${record.id}/submission`, {complete}, generateActions);
};

export const updateRecord = ({id, name, dateOfBirth, admissionDate, medicaidId}) => async (dispatch, getState, {schema}) => {
  return await api(dispatch).post(`records/${id}`, {name, dateOfBirth, admissionDate, medicaidId}, response => [
    {type: RECORD_UPDATED, payload: {...normalize(response, schema.patient)}},
    sendNotification(`${name} record saved.`)
  ]);
};

const mapFormValue = (formData) => {
  const x = Object.keys(formData).reduce((a, c) => ({...a, [c]: formData[c].value}), formData);
  console.log("mapFormValue", x)
  return x;
};


// WEBPACK FOOTER //
// ./src/modules/record/record.actions.js